module.exports = __webpack_public_path__ + "img/live.75135afc.jpg";